import React from "react";
import Title from "antd/lib/typography/Title";
import colors from "../../constants/colors";

export interface Props {
  title: string;
}

const TitleUnderlined: React.FC<Props> = ({ title }) => {
  return (
    <Title>
      <span
        style={{
          textDecoration: "underline",
          textDecorationColor: colors.secondary,
          fontSize: "1em",
        }}
      >
        {title}
      </span>
    </Title>
  );
};

export default TitleUnderlined;
